import React from 'react'

interface TableHeader {
  id: string;
  label: string;
}

interface TheadProps {
  headers: TableHeader[];
}

export const Thead: React.FC<TheadProps> = ({ headers }) => {
  return (
    <thead>
      <tr className="bg-gray-100">
        {headers.map((header) => (
          <th key={header.id} className="border border-gray-300 px-4 py-2">
            {header.label}
          </th>
        ))}
      </tr>
    </thead>
  )
}
